export default {
  SET_META: 'CUSTOMER/SET_META',
  SET_BASIC_INFO: 'CUSTOMER/SET_BASIC_INFO',
  REQUEST_META: 'CUSTOMER/REQUEST_META',
}
